import { SupportTierChoices } from './types'

export { SUPPORT_EMAIL } from '../constants'

export enum SupportReqType {
  ACC_OR_BILL = 'Account or billing',
  SECURITY = 'Security',
  FP = 'False positive',
  BUG = 'Bug',
  FEEDBACK = 'Feedback'
}

export enum SupportReqFormType {
  COMMON,
  PER_TYPE
}

type SupportHandlers = {
  'files-change'?: (files: File[]) => void
  submit?: (validatedFormData: SupportValidationData) => void | Promise<void>
}

type BaseSupportComponent = {
  componentToRender: unknown
  bind: Record<string, unknown> | false
  handlers: SupportHandlers | false
}

type CommonFormRender = {
  type: SupportReqFormType.COMMON
} & BaseSupportComponent

type PerTypeFormRender = { type: SupportReqFormType.PER_TYPE } & {
  [key in SupportTierChoices]: BaseSupportComponent
}

export type SupportFormT = CommonFormRender | PerTypeFormRender

export type SupportValidationData = {
  fromEmail: string
  ccEmails: string
  subject: string
  supportText: string
  supportHTML: string
}

export enum SupportPageStatusT {
  default,
  success,
  error
}
